import type { AppSidebarGroup } from "../../types";
import { Flex } from "../flex";
import { SidebarNavGroup } from "../sidebar-nav-group/SidebarNavGroup";
import { SidebarNavItem } from "../sidebar-nav-item/SidebarNavItem";
import { SidebarNavLogo } from "../sidebar-nav-logo/SidebarNavLogo";
import styles from "./SidebarNav.module.scss";

export const SidebarNav = ({
  groups,
  productName,
  version,
  brandmarkSrc,
}: {
  groups: AppSidebarGroup[];
  productName: string;
  version: string;
  brandmarkSrc: string;
}) => {
  const mainGroups = groups.filter((group) => !group.pinned);
  const pinnedGroups = groups.filter((group) => group.pinned);

  return (
    <Flex direction="column" className={styles["comp"]}>
      <div className={styles["comp__header"]}>
        <SidebarNavLogo
          productName={productName}
          version={version}
          brandmarkSrc={brandmarkSrc}
        />
      </div>

      <div className={styles["comp__scrollArea"]}>
        <div className={styles["comp__fadeTop"]} aria-hidden />
        <div className={styles["comp__fadeBottom"]} aria-hidden />
        <div className={styles["comp__scrollWrapper"]}>
          <div className={styles["comp__scrollContent"]}>
            <Flex direction="column" gap={32} style={{ width: "100%" }}>
              {mainGroups.map((group) => (
                <SidebarNavGroup
                  key={group.group}
                  label={group.group}
                  collapsible={group.collapsible}
                  defaultOpen={group.defaultOpen}
                >
                  {group.items.map((item) => (
                    <SidebarNavItem
                      key={item.href}
                      href={item.href}
                      icon={item.icon}
                      label={item.label}
                      subItems={item.subItems}
                      excludeActivePathPrefixes={item.excludeActivePathPrefixes}
                      onClick={item.onClick}
                    />
                  ))}
                </SidebarNavGroup>
              ))}
            </Flex>
          </div>
        </div>
      </div>

      {pinnedGroups.map((group) => (
        <div key={group.group} className={styles["comp__footer"]}>
          <SidebarNavGroup
            label={group.group}
            collapsible={group.collapsible}
            defaultOpen={group.defaultOpen}
          >
            {group.items.map((item) => (
              <SidebarNavItem
                key={item.href}
                href={item.href}
                icon={item.icon}
                label={item.label}
                subItems={item.subItems}
                excludeActivePathPrefixes={item.excludeActivePathPrefixes}
                onClick={item.onClick}
              />
            ))}
          </SidebarNavGroup>
        </div>
      ))}
    </Flex>
  );
};
